module.exports = __webpack_public_path__ + "static/img/img1.8871160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/img1.png
// module id = V5Ne
// module chunks = 8